module.exports = __webpack_public_path__ + "img/pdf-download.0d965514.png";